﻿$.fn.dxCtrlButton = function custom_dxCtrlButton(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbutton dx-ctrl");
        this.createInstance(new cdxCtrlButton(this, option));
    }
    return this;
}

window.cdxCtrlButton = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;
    if (typeof option.focusStateEnabled == 'undefined') option.focusStateEnabled = false;
    //if (typeof option.height == 'undefined' && typeof option.icon2 != 'undefined') option.height = 36;
    //if (typeof option.width == 'undefined' && typeof option.icon2 != 'undefined') option.width = 36;
    if (typeof option.height == 'undefined') option.height = 36;
    if (typeof option.width == 'undefined' && typeof option.text == "undefined") option.width = 36;
    if (typeof option.visible == 'undefined') option.visible = true;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
            switch (name) {
                case "border":
                    if (typeof option[name] != 'undefined') $DivEnveloppe.css("border", option[name])
                    break;
                case "visible":
                    if (!option.visible) { $DivEnveloppe.css("display", "none") } else { $DivEnveloppe.css("display", "inline-block") };
                    break;
                case "value":
                    dx.element().css({
                        "background-color": ((option.value) ? theme.toastSuccess : "")
                    });
                    break;
                case "icon":
                    dx.element().find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                    break;
                case "icon2":
                    var $icon2 = $(dx.element().find(".dxicon2")[0])
                    $icon2.attr("class","")
                    $icon2.addClass("dxicon2 " + value)
                    break;
            }
        }
    }

    container.css("opacity", "0.8");
    this.dxBtHome = null;
    var isOnFront = false;
    var dx = null;
    var $DivEnveloppe = null;
    var dxTooltipHover = null
    function mConstruit() {
        container.empty();

        $DivEnveloppe = $("<div style='display:inline-block;position:relative;' class='dxctrlbuttonenveloppe'/>").appendTo(container)
        var onContentReadyBase = option.onContentReady;
        if (typeof option.focusStateEnabled == 'undefined') option.focusStateEnabled = false;
        option.onContentReady = function (e) {
            e.component.element().css("overflow", "visible");
            e.component.element().css("min-width",option.width + "px")
            if (typeof option.icon == 'object' && option.icon != null) {
                option.icon.addClass("dx-icon")
                e.component.element().find(".dx-button-content").append(option.icon.clone())
            }
            //if (typeof option.colorIcone == 'undefined') { $(e.component.element().find(".dx-icon")).addClass("dx-theme-accent-as-text-color") }
            else { $(e.component.element().find(".dx-icon")).css("color", option.colorIcone); }
            $(e.component.element().find(".dx-button-text")).addClass("dx-theme-accent-as-text-color")
            $(e.component.element().find(".dx-icon")).css({
                "font-size": (option.height * 20 / 36) + "px",
                "width": (option.height * 24 / 36) + "px"
            })
            if (typeof option.icon2 != 'undefined') {

                //if (typeof option.height == 'undefined') {
                //    window.setTimeout(function () {
                //        option.height = container.innerHeight();
                //        mInitIcone2()
                //    },800)
                //} else { mInitIcone2() }
                //function mInitIcone2() {
                if (typeof option.height == 'undefined') option.height = 48
                e.component.element().find(".dx-icon").css("position", "relative")
                //window.setTimeout(function () {
                //var height = $(e.component.element().find(".dx-icon")).innerHeight()
                var $i = $("<i class='" + option.icon2 + " dxicon2' style='position:absolute;bottom:-" + ((option.height / 2.5) / 4) + "px;right:-" + ((option.height / 2.5) / 4) + "px;font-size:" + option.height / 3 + "px;opacity:1'/>").appendTo(e.component.element().find(".dx-icon"))
                if (typeof option.colorIcone2 != 'undefined') { $i.css("color", option.colorIcone2) }
                else { $i.css("color", theme.backgroundcolorAccent) }
                if (typeof option.opacityIcone2 != 'undefined') $i.css("opacity", option.opacityIcone2)
                //}, 0)
                ////var $i = $("<i class='" + option.icon2 + "' style='position:absolute;bottom:-" + ((option.height / 2.5) / 4) + "px;right:-" + ((option.height / 2.5) / 4) + "px;font-size:" + option.height / 2.5 + "px;opacity:1'/>").appendTo(e.component.element().find(".dx-icon"))
                //}

            }
            if (typeof option.icon3 != 'undefined') {
                e.component.element().find(".dx-icon").css("position", "relative")
                //var $i = $("<i class='" + option.icon2 + "' style='position:absolute;bottom:" + option.height / 10 + "px;right:" + option.height / 10 + "px;font-size:" + option.height / 2.5 + "px;opacity:1'/>").appendTo(e.component.element().find(".dx-button-content"))
                var $i = $("<i class='" + option.icon3 + "' style='position:absolute;top:-" + ((option.height / 2.5) / 4) + "px;right:-" + ((option.height / 2.5) / 4) + "px;font-size:" + option.height / 2.5 + "px;opacity:1'/>").appendTo(e.component.element().find(".dx-icon"))
                if (typeof option.colorIcone3 != 'undefined') $i.css("color", option.colorIcone3)
                if (typeof option.opacityIcone3 != 'undefined') $i.css("opacity", option.opacityIcone3)
                if (typeof option.leftIcone3 != 'undefined') $i.css({
                    "left": "-" + ((option.height / 2.5) / 4) + "px",
                    "right": ""
                })
                if (option.bottomIcone3) $i.css({
                    "bottom": "-" + ((option.height / 2.5) / 4) + "px","top":""
                })
                //$("<i class='" + option.icon2 + " dx-theme-accent-as-text-color' style='position:absolute;bottom:0px;right:Opx;font-size:" + option.height / 2.5 + "px;opacity:1'/>").appendTo(e.component.element().find(".dx-button-content"))
            }
            if (option.iconAfter) {
                container.find(".dx-icon").appendTo(container.find(".dx-button-content"));
                container.find(".dx-icon").css("margin-left", "8px");
            }
            //if (typeof option.iconHover != 'undefined') {
            //   var comp =  e.component.element().find(".dx-icon")
            //    comp.on("mouseenter", function () {
            //        $(e.component.element().find(".dx-icon")).addClass(option.iconHover);
            //        $(e.component.element().find(".dx-icon")).removeClass(option.icon);
            //    });
            //    comp.on("mouseleave", function () {
            //        $(e.component.element().find(".dx-icon")).removeClass(option.iconHover);
            //        $(e.component.element().find(".dx-icon")).addClass(option.icon);
            //    });
            //}
            if (typeof onContentReadyBase != 'undefined') onContentReadyBase(e)
        }
        var onClick = option.onClick;
        var tt = null;
        option.onClick = function (e) {
            if ($DivJauge) { mNotify("Traitement est en cours. Veuillez patienter...", "warning", 3000); return; }
            if (tt) tt.hide();
            if (typeof option.onSwitch != 'undefined' && option.onSwitch) {
                option.value = !option.value
                e.value = option.value
                dx.element().css({
                    "background-color": ((option.value) ? theme.toastSuccess : "")
                });
                option.onSwitch(e);
            }
            e.dxCtrl = Me
            if (typeof onClick != 'undefined') onClick(e);
        }
        if (typeof option.html != 'undefined') option.text = "."
        var onoptionchanged = option.onOptionChanged
        option.onOptionChanged = function (e) {
            if (e.name == "text") {
                window.setTimeout(function () {
                    if (option.iconAfter) {
                        container.find(".dx-icon").appendTo(container.find(".dx-button-content"));
                        container.find(".dx-icon").css("margin-left", "8px");
                    }
                    e.element.find(".dx-button-text").addClass("dx-theme-accent-as-text-color")
                    e.element.find(".dx-icon").addClass("dx-theme-accent-as-text-color")
                }, 0);
            }
        }
        dx = $("<div style='" + ((option.html != 'undefined') ? "height:auto;" : "") + "'/>").appendTo($DivEnveloppe).dxButton(option).dxButton("instance")
        if (typeof option.value != 'undefined' && option.value != null) {
            dx.element().css({
                "background-color": ((option.value) ? theme.toastSuccess : "")
            });
        }
        if (typeof option.html != 'undefined') dx.element().find(".dx-button-text").html(option.html);

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            // if (typeof option.txtTooltipPosition == 'undefined') option.txtTooltipPosition = "top"
            //dxTooltipHover = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: option.txtTooltipPosition, contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        dx.mRempliCompteur = function (value) { Me.mRempliCompteur(value); }
        dx.performClick = function (value) { Me.performClick(); }

        //container.css("display", "inline");
        if (typeof option.border != 'undefined') $DivEnveloppe.css("border", option.border)
        if (dx.element().css("border-radius").contains("%")) {
            $DivEnveloppe.css("border-radius", dx.element().css("border-radius"));
        } else {
            $DivEnveloppe.css("border-radius", (parseInt(dx.element().css("border-radius").replace("px", "")) + parseInt($DivEnveloppe.css("border-width").replace("px", ""))) + "px");
        }
        if (typeof option.width != 'undefined' && option.width != null && option.width.toString().contains("%")) $DivEnveloppe.css("width", option.width);
        if (typeof option.height != 'undefined' && option.height !=null && option.height.toString().contains("%")) $DivEnveloppe.css("height", option.height);

        if (!option.visible) $DivEnveloppe.css("display", "none");

        if (typeof option.textAlign != 'undefined') {
            container.find(".dx-button-content").css("text-align", option.textAlign)
            container.find(".dx-button-text").css("width", "100%")
        }
        if (typeof option.text == 'undefined' || option.text == null || option.text.length == 0) container.find(".dx-button-content").css("padding", "0")

        if (option.animate) {
            Me.element().on("mouseenter", function () { if (typeof option.disabled == 'undefined' || !option.disabled) mouseenter() })
            Me.element().on("mouseleave", function () { mouseleave() })
        }
        animateLeftInitial = Me.element().css("left").replace("px", "")
    }

    this.mRepaint = function () { mConstruit() }

    this.hideTooltip = function () {
        if (dxTooltipHover) dxTooltipHover.hide()
    }

    this.mChangeHtmlText = function (html) {
        container.find(".dx-button-text").html(html)
    }

    var $DivJauge = null
    this.mShowJauge = function () {
        if ($DivJauge == null) {
            $DivJauge = $("<span style='position:absolute;top:0;left:0;width:100%;height:100%;display:none;opacity:0.6;border-radius:50%;z-index:5;'/>")
            $DivEnveloppe.find(".dx-button").prepend($DivJauge)
            var jauge = $("<div style=''/>").appendTo($DivJauge).dxCtrlJauge({
                height: 30,
                width: 30
            }).dxCtrlJauge("instance")
            jauge.mShow()
            $DivJauge.css("position", "absolute")
        }
        //dx.option("disabled", true)
        $DivJauge.show()
    }

    this.mHideJauge = function () {
        $DivJauge.remove()
        $DivJauge = null;
        //dx.option("disabled", false)
    }

    this.animate = function (tempo) {
        if (inMouseEnter) return;
        if (typeof tempo == 'undefined') tempo = 0
        window.setTimeout(function () { mouseenter() }, tempo)
        window.setTimeout(function () { mouseleave() }, 150 + tempo)
    }

    if (typeof option.coef_anime == "undefined") option.coef_anime = 2
    var inMouseEnter = false
    var animateLeftInitial = null
    function mouseenter() {
        inMouseEnter = true;
        Me.element().find(".dx-button").stop()
        Me.element().stop()
        Me.element().find(".dx-button").animate({
            width: (option.width * option.coef_anime) + "px",
            'min-width': (option.width * option.coef_anime) + "px",
            height: (option.height * option.coef_anime) + "px"
        }, 150)
        var anime = { "z-index": 3000 }
        if (Me.element().css("position") == "absolute") {
            //animateLeftInitial = Me.element().css("left").replace("px", "")
            if (typeof animateLeftInitial != 'undefined' && animateLeftInitial != null) {
                anime.left = ((option.width - (option.width * option.coef_anime)) / 2) + "px"
                //anime.left = (option.width / option.coef_anime/4) + "px"
            }
        }
        Me.element().animate(anime, 150)
    }
    function mouseleave() {
        Me.element().find(".dx-button").stop()
        Me.element().stop()
        Me.element().find(".dx-button").animate({
            "min-width": option.width + "px",
            width: option.width + "px",
            height: option.height + "px"
        }, 300)
        var anime = { "z-index": 1 }
        if (Me.element().css("position") == "absolute") {
            if (typeof animateLeftInitial != 'undefined' && animateLeftInitial != null) {
                anime.left = animateLeftInitial + "px"
            }
        }
        Me.element().animate(anime, 300)
        inMouseEnter = false
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    this.performClick = function () {
        option.onClick({
            dxCtrl: Me,
            component: dx,
            element: dx.element()
        })
    }

    this.mSelect = function () {
        this.element().find(".dx-button").css("background-color", theme.backgroundcolorAccent)
        this.element().find(".dx-icon").removeClass("dx-theme-accent-as-text-color")
        this.element().find(".dx-button-text").removeClass("dx-theme-accent-as-text-color")
    }
    this.mUnSelect = function () {
        this.element().find(".dx-button").css("background-color", "")
        this.element().find(".dx-icon").addClass("dx-theme-accent-as-text-color")
        this.element().find(".dx-button-text").addClass("dx-theme-accent-as-text-color")
    }

    this.focus = function () {
        dx.element().find(".dx-button-content").addClass("dx-theme-accent-as-background-color")
        dx.element().find(".dx-button-text").removeClass("dx-theme-accent-as-text-color")
    }
    this.removeFocus = function () {
        dx.element().find(".dx-button-content").removeClass("dx-theme-accent-as-background-color")
        dx.element().find(".dx-button-text").addClass("dx-theme-accent-as-text-color")
    }

    var $indicateur = null;
    this.mRempliCompteur = function (value) {
        if (!$indicateur) {
            var fontSize = 12
            var height = 18
            if (typeof option.height != 'undefined' && option.height > 36) {
                fontSize = 12 / 36 * option.height
                height = 18 / 36 * option.height
            }
            if (typeof option.fontsize_compteur != 'undefined') { fontSize = option.fontsize_compteur }
            if (typeof option.height_compteur != 'undefined') { height = option.height_compteur }
            $indicateur = $("<div class='compteur' style='position:absolute;top:0;right:-6px;display:none;min-width:18px;'><div style='border-radius:50%;padding:3px 2px 2px 2px;font-weight:bold;background-color:red;height:" + height + "px;opacity:0.8;font-size:" + fontSize + "px;line-height:110%;;text-align:center;' class='sscompteur'></div></div>").appendTo(dx.element().find(".dx-button-content"))
            //if (option.animCompteur) $indicateur.addClass("blinkscalealways")
            if (typeof option.cssCompteur != 'undefined') $indicateur.find("div").css(option.cssCompteur)
        }
        if (value > 0) {
            if ($indicateur.is(":visible")) {
                $indicateur.stop()
                $indicateur.fadeOut(250, "swing", function () {
                    if (value > 99) { $($indicateur.find("div")).html("<i class='fas fa-infinity' title='" + value + "'></i>") }
                    else { $($indicateur.find("div")).text(value) }
                    $indicateur.stop()
                    $indicateur.fadeIn(250);
                });
            }
            else {
                if (value > 99) { $($indicateur.find("div")).html("<i class='fas fa-infinity' title='" + value + "'></i>") }
                else { $($indicateur.find("div")).text(value) }
                $indicateur.stop()
                $indicateur.fadeIn(300);
            }
        } else {
            $indicateur.stop()
            $indicateur.fadeOut(300);
        }
    }

    mConstruit();

    //return dx;
}